module.exports = __webpack_public_path__ + "ce7620717d3914b0fcfaadd6bb815cac.pdf";